import store from "../../../store";
import type { Pages, Page } from "./pagesTypes";
import StructureAPI from "../structure/structureApi";
import { loadTemplates } from "../templates/templateApi";
import { updateEditor } from "../editor/editorActions";
import { setEditableComponentId } from "../../textEditor/textEditorActions";
import {
  saveActivePageSelection,
  clearStoredActivePageSelection,
} from "../../../../utils/Helpers";
import {
  SET_WEBPAGE_ACTIVE,
  ADD_WEBPAGE,
  DELETE_WEBPAGE,
  UPDATE_WEBPAGE,
  UPDATE_WEBPAGES,
} from "./pagesReducer";

export function setActivePage(payload: Pages["active"]) {
  if (payload) {
    const currentEditor = store.getState().builder.editor;
    updateEditor({
      ...currentEditor,
      component_id: null,
      component_parent_id: null,
      component_uuid: null,
      component_parent_uuid: null,
      template: null,
    });
    setEditableComponentId(null);
    const list = store.getState().builder.pages.list as Page[];
    const page = list.find((p) => p.uuid === payload);
    const numericId = page?.id;
    if (numericId != null && numericId > 0) {
      StructureAPI.loadWebpageComponents(numericId);
      void loadTemplates();
    }
    saveActivePageSelection(payload, 24);
  } else {
    clearStoredActivePageSelection();
  }
  return store.dispatch(SET_WEBPAGE_ACTIVE(payload));
}

export function updateWebpages(payload: Pages["list"]) {
  return store.dispatch(UPDATE_WEBPAGES(payload));
}

export function updateWebpage(payload: { uuid: string; data: Page }) {
  return store.dispatch(UPDATE_WEBPAGE(payload));
}

export function addNewWebpage(payload: Page) {
  return store.dispatch(ADD_WEBPAGE(payload));
}

export function deleteWebpageByUuid(uuid: string) {
  return store.dispatch(DELETE_WEBPAGE({ uuid }));
}
